import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const AppVersionReducer = createSlice({
  name: "AppVersion",
  initialState,
  reducers: {
    defaultAction: (state, { payload }) => {
      console.log("AppVersionReducer state and payload", state, payload);
    },
  },
});

const { reducer, actions } = AppVersionReducer;
export const { defaultAction } = actions;
export default reducer;
